export enum DirectionEnum {
  Entry = 1,
  Exit = 2,
}
